// src/index.tsx
import React from 'react';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import { awsExports } from './awsConfig';
import store from './state/store';
import App from './App';
import { createRoot } from 'react-dom/client';

// Configure Amplify
Amplify.configure(awsExports);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);
